import { useState } from 'react';
import ContactModal from './Contact/ContactModal.tsx';
import ImageCard from './Contact/ImageCard.tsx';
import { useLanguage } from '../contexts/LanguageContext';


const Contact = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const { translations } = useLanguage();


  return (
    <div id="contact" className="py-5 bg-white">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-light text-gray-900 mb-5">{translations.contact}</h2>
        
        <div className="grid  grid-cols-1   lg:grid-cols-5 xl:grid-cols-5 gap-3">

            {/* Katja */}
            <div className="relative  overflow-hidden rounded-lg   col-span-1 ">
                <ImageCard
                    imageSrc="../../assets/Pictures/Katja_Ludwig_novobit.jpg"
                    hoverImageSrc="../../assets/Pictures/Katja_Ludwig_novobit.jpg"
                    title=" "
                    onClick={() => setShowContactModal(true)}
                />
            </div>

          {/* Small Talk Section */}
          <div className="relative   overflow-hidden rounded-lg  lg:col-span-2  xl:col-span-2  col-span-1">
            <ImageCard
              imageSrc={translations.contact_1_2}
              hoverImageSrc={translations.contact_1_2}
              title=" "
              onClick={() => setShowContactModal(true)}
            />
          </div>

         <div className="relative   overflow-hidden rounded-lg  col-span-1  ">
            <ImageCard
                imageSrc="../../assets/Pictures/Michael_Rix.jpg"
                hoverImageSrc="../../assets/Pictures/Michael_Rix.jpg"
                title=" "
                onClick={() => setShowContactModal(true)}
            />
        </div>

          {/* Hans-Joachim */}
          <div className="relative   overflow-hidden rounded-lg col-span-1 ">
            <ImageCard
              imageSrc="../../assets/Pictures/Andreas_Simon_novobit.jpg"
              hoverImageSrc="../../assets/Pictures/Andreas_Simon_novobit.jpg"
              title=" "
              onClick={() => setShowContactModal(true)}
            />
          </div>
        </div>
      </div>

      <ContactModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    </div>
  );
};

export default Contact;
